/** App-level JSON heartbeat interval (separate from WebSocket `ping` frames). */
export const BRIDGE_APP_HEARTBEAT_INTERVAL_MS = 10_000;

/** Must match Bridge DO `BRIDGE_HEARTBEAT_SEQ_MAX`. */
export const BRIDGE_HEARTBEAT_SEQ_MAX = 0x7fff_fffe;

/** Close the bridge socket (triggers reconnect) after this many intervals without an ack for the last sent seq. */
export const BRIDGE_HEARTBEAT_MISSED_ACKS_BEFORE_RECONNECT = 4;

/** Rolling window of RTT samples (ms) averaged into the next heartbeat `m` field. */
export const BRIDGE_HEARTBEAT_RTT_SAMPLE_MAX = 5;
